import { SearchParams } from '@/types/common'
import { CreateFloor, UpdateFloor } from '@/types/floor'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const floorApi = {
  getAll(searchParams: SearchParams = {}) {
    const url = '/api/floor'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(locationId?: string) {
    const url = `/api/floor/${locationId}`
    return axiosClient.get(url)
  },

  // Only the levels that already have a floor plan image
  getWithOverlayByLocation(locationId: string) {
    const url = `/api/floor/${locationId}?requiredOverylay=1`
    return axiosClient.get(url)
  },

  getByDefaultFloorId(locationId?: number) {
    const url = `/api/floor/getdefaultfloor/${locationId}`
    return axiosClient.get(url)
  },

  getByInterfaceId(interfaceId?: string, id?: string) {
    const url = `/api/floor/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  deleteFloor(interfaceId: number, id: number) {
    const url = `/api/floor?interfaceid=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },

  create(payload: CreateFloor) {
    const url = '/api/floor'
    return axiosClient.post(url, payload)
  },

  update(payload: UpdateFloor) {
    const url = '/api/floor'
    return axiosClient.put(url, payload)
  },
}

export default floorApi
